import React, { useState } from "react";
import {Dialog, DialogActions, Grid } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import { useSetState } from "Helpers/Hooks";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import UnitBarService from "Services/http/endpoints/design/UntiBarService";
import StatusHandler from "Helpers/StatusHandler";
import { DESIGN_UNIT_LIST, SELECTED_UNIT_ID } from "Stores/actionTypes";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons"
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

export default function EditUnitNew({unit, disabled}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false)
  
  const { unitList, selectedUnitImage, selectedUnitINfo, selectedUnitId, unitListPagination } = useSelector(
    (state) => ({
      unitList: state.design.unitList,
      selectedUnitImage: state.design.selectedUnitImage,
      selectedUnitINfo: state.design.selectedUnitINfo,
      selectedUnitId: state.design.selectedUnitId,
      unitListPagination: state.design.unitListPagination,
    })
  );
  const [data, setData] = useState(null);
  const [formValid, setFormValid] = useState({});

  const onShowDialog = (status) => {
    setShow(status);
  }

  const [controls, setControls] = useSetState({
    nameUnit: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        xs: 12,
        sm: 4,
      },
    },
    placeLocation: {
      type: "text",
      value: "",
      validation: null,
      col: {
        xs: 12,
        sm: 4,
      },
    },
    numberUnit: {
      type: "number",
      value: "1",
      validation: {
        required: true,
      },
      col: {
        xs: 12,
        sm: 4,
      },
    },
  })

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  }

  const onEnter = () => {
    setControls({ nameUnit: { value: unit.Name } });
    setControls({ placeLocation: { value: unit.Location } });
    setControls({ numberUnit: { value: unit.CountUnit } });
    setData(unit);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    const { nameUnit, placeLocation, numberUnit } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdUnit: unit.Id,
          Name: nameUnit.value,
          Location: placeLocation.value,
          CountUnit: numberUnit.value,
        };
        const response = await UnitBarService.updateUnit(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: "یونیت مورد نظر با موفقیت ویرایش شد",
            customClass: "success",
          });
        }
        const updateList = [...unitList];
        const index = updateList.findIndex(row => row.Id === unit.Id);
        updateList[index] = {
          ...updateList[index],
          Name: nameUnit.value,
          Location: placeLocation.value,
          CountUnit: numberUnit.value,
        };
        dispatch({
          type: DESIGN_UNIT_LIST,
          unitList: updateList,
          unitListPagination: unitListPagination,
        });
        onShowDialog(false);
        setLoading(false);
      } catch (err) {
      console.error('[catch error]', err)
    }
    } else if (R.isEmpty(formValid)) {
      onShowDialog(false);
      setLoading(false);
    } else {
      showNotify({
        text: "لطفاً اطلاعات را به درستی وارد کنید.",
        customClass: "error",
      });
    }
  };

  return (
    <>
      <BackDropLoading loading={loading}/>
      <MuiIconButton
        title={<Translator id={"editUnit"} />}
        icon={<Icons.Pencil size={15}/>}
        className="warning-fill"
        onClick={() => onShowDialog(true)}
        disabled={disabled}
      />
      <Dialog
        dir={direction}
        open={show}
        onEnter={onEnter}
        onClose={() => onShowDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>ویرایش یونیت</p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} className="d-flex justify-content-center mb-2">
                <img
                  src={`data:image/png;base64, ${data?.Image}`}
                  alt=""
                  width={200}
                />
              </Grid>
              {
                Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                      />
                    </Grid>
                  );
                })
              }
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={() => onShowDialog(false)}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}